import { Sidebar } from "../components/SideBar";
import CourseHeader from "../components/CourseHeader";
import { useState } from "react";

export default function AdminPannel({ children }) {
  const [activeNavItem, setActiveNavItem] = useState('Course List');

  return (
    <div className="flex h-screen overflow-hidden">
  
      <div className="hidden md:block fixed top-16 left-0 h-full w-[280px] z-50">
        <Sidebar onActiveItemChange={setActiveNavItem} />
      </div>

      
      <div className="flex-1 ml-0 md:ml-[280px] flex flex-col h-screen overflow-hidden">

        <div className="flex-shrink-0">
          <CourseHeader activeNavItem={activeNavItem} />
        </div>

        <div className="flex-1 mt-22 md:mt-16 flex flex-col min-h-0">
          {children}
        </div>
      </div>
    </div>
  );
}